import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Important:`}</strong>{` Surveys are not immediately available on page load. If you call `}<inlineCode parentName="p">{`renderSurvey`}</inlineCode>{` before surveys have been initialized, the call may fail. To avoid this, use the `}<inlineCode parentName="p">{`posthog.onSurveysLoaded(callback)`}</inlineCode>{` method. This ensures surveys are fully initialized before attempting to render them.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      